import type { WabunkaReservationFormStep2 } from '@/wabunka-src/features/Experience/subFeatures/Reservation/models/wabunkaReservations';

/** 新動線の Booking for a company or someone else? の開閉。閉じるときは会社名と代理予約の両方を落とすので、どちらかが残っていれば開いている */
export const isCompanyOrSomeoneElseFormOpen = (step2: WabunkaReservationFormStep2): boolean => step2.shouldShowSomeoneElseForm || step2.companyName !== '';

/** 開いた折りたたみで参加者の氏名・メールを求めるか。会社名だけなら予約者本人が参加者になり、参加者の欄に 1 つでも入れたら全部を求める（D-036） */
export const requiresParticipantDetails = (step2: WabunkaReservationFormStep2): boolean =>
  step2.companyName === '' || [step2.participantFirstName, step2.participantLastName, step2.forSomeoneElseEmail].some((value) => value !== '');
